import api from "@/api";

const namespaced = true

const state = {
  incidentSafetyUtilizationData: null,
  routes: []

}

const getters = {
  incidentSafetyUtilizationData: (state) => state.incidentSafetyUtilizationData,
  routes: (state) => state.routes
}

const mutations = {
  SET_INCIDENT_SAFETY_UTILIZATION_DATA: (state, payload) => {
    state.incidentSafetyUtilizationData = payload
  },
  SET_ROUTES: (state, payload) => {
    state.routes = payload
  }
}

const actions = {
  async fetchIncidentSafetyUtilization({ commit }, payload) {
    try {
      const { data } = await api.getIncidentSafetyUtilization(payload)

      if (data.error) {
        commit('SET_INCIDENT_SAFETY_UTILIZATION_DATA', null)
        return
      }

      commit('SET_INCIDENT_SAFETY_UTILIZATION_DATA', data)
    } catch (err) {
      throw err
    }
  },
  async fetchRoutes({ commit }) {
    try {
      const { data } = await api.getIncidentSafetyUtilRoutes()
      commit('SET_ROUTES', data)
    } catch (err) {
      throw err
    }
  }
}

export default { namespaced, state, getters, mutations, actions }